/**
 * Creates a dictionary which indexes objects by one of their property
 * @param data An array of objects.
 * @param key The key used to index the objects in the dictionary.
 * @returns A dictionary where keys are the specified property of the objects and values are the corresponding objects.
 */
export function createLookupById<T, K extends keyof T>(data: T[], key: K): { [P in keyof T[K]]: T } {
    // Initialize the accumulator as an empty object with keys of type K.
    // Iterate through each object in the array, using the specified key as the dictionary key.
    // Combine the current dictionary with a new key-value pair for each object.
    return data.reduce((prev: { [P in keyof T[K]]: T }, curr: T) => ({ ...prev, [ curr[ key as string ] ]: curr }), {} as { [P in keyof T[K]]: T });
}


